const colorSelect = document.getElementById('color-select');
const colorSourceElement = document.getElementById('sidebarBlock-content-1');
const colorSelectMenu = document.getElementById('color-select-menu');
const colorSelectMenuBox = document.getElementById('color-select-menu-box');

const sizeSelect = document.getElementById('size-select');
const sizeSourceElement = document.getElementById('sidebarBlock-content-2');
const sizeSelectMenu = document.getElementById('size-select-menu');
const sizeSelectMenuBox = document.getElementById('size-select-menu-box');

if(colorSourceElement && sizeSourceElement && window.innerWidth < 1025) {
    colorSelectMenuBox.innerHTML = colorSourceElement.innerHTML;
    sizeSelectMenuBox.innerHTML = sizeSourceElement.innerHTML;

    colorSelect.addEventListener('click', function() {
        colorSelectMenu.classList.add('open-color-select-menu')
    });

    sizeSelect.addEventListener('click', function() {
        sizeSelectMenu.classList.add('open-color-select-menu')
    });

    document.addEventListener('click', function(event) {
        if (!colorSelectMenu.contains(event.target) && event.target !== colorSelect) {
            colorSelectMenu.classList.remove('open-color-select-menu')
        }

        if (!sizeSelectMenu.contains(event.target) && event.target !== sizeSelect) {
            sizeSelectMenu.classList.remove('open-color-select-menu')
        }
    });

    // 获取所有具有特定class的li元素
    const listItems = document.querySelectorAll('.toolbar-item .facets__item');
    // 为每个li元素添加点击事件监听器
    listItems.forEach(item => {
        item.addEventListener('click', function() {
            const checkbox = item.querySelector('input[type="checkbox"]');
            
            // 如果它被选中（checked）了 就给他去掉checked 否则加上checked
            if (checkbox.checked) {
              console.log('选中');
              checkbox.removeAttribute('checked');
            } else {
              console.log('未选中');
              checkbox.setAttribute('checked', 'checked');
            }
        });
    });

}

if(document.querySelector('#size-select-menu .js-facet-remove .text')){
    document.querySelector('#size-select-menu .js-facet-remove .text').addEventListener('click', function() {
        localStorage.removeItem('sizeListNew');// 清除选中size本地存储
    })
}
